import { animated, useSprings } from '@react-spring/web';

import { cn } from '@app/shared/utils/common';
import {
  POSITION_CARD_ONE,
  POSITION_CARD_TWO,
  POSITION_CARD_THREE,
} from '@app/shared/constants/dailyCardPreview';
import type { CardIndex } from '@app/shared/types/pages/dailyCardPreview';
import { taroCardOneIcon, taroCardTwoIcon, taroCardThreeIcon } from '@app/assets';

interface CardsSectionProps {
  selectedCard: CardIndex;
  onCardClick: (cardIdx: CardIndex) => void;
}

const TARO_ICONS = [taroCardOneIcon, taroCardTwoIcon, taroCardThreeIcon];
const SPRING_CONFIGS = [POSITION_CARD_ONE, POSITION_CARD_TWO, POSITION_CARD_THREE];

export function CardsSection({ selectedCard, onCardClick }: CardsSectionProps) {
  const [cardSprings] = useSprings(
    SPRING_CONFIGS.length,
    (index) => SPRING_CONFIGS[index][selectedCard],
    [selectedCard]
  );

  return (
    <section className="mt-6 flex items-center justify-center">
      {TARO_ICONS.map((icon, idx) => (
        <animated.img
          key={idx}
          src={icon}
          alt={`taro card ${idx + 1}`}
          className={cn('w-[120px]', idx === 1 && 'relative z-1')}
          style={cardSprings[idx]}
          onClick={() => onCardClick((idx + 1) as CardIndex)}
        />
      ))}
    </section>
  );
}
